export const FORM_ITEM_SIZE_LIST = { xs: 12, md: 6 };
export const FORM_BUTTON_SIZE_LIST = { xs: 10, md: 8, lg: 6 };
export const FORM_SECTION_SIZE_LIST = { xs: 10, md: 8, lg: 6 };
